import axios from 'axios'

export default {
  updateProjectStatus(params) {
    return axios.post('/api/rendering/admin/front/outsourcing/project/updateProjectStatus', params)
  },
  getApplyCountStatInfo(params) {
    return axios.post(
      '/api/rendering/admin/front/outsourcing/project/getApplyCountStatInfo',
      params,
    )
  },
  queryProjectApplyList(params) {
    return axios.post(
      '/api/rendering/admin/front/outsourcing/operatingRecord/projectApplicationRecord',
      params,
    )
  },
  getQualification(params) {
    return axios.post(
      '/api/rendering/admin/front/outsourcing/qualification/getQualification',
      params,
    )
  },
  projectRecord(params) {
    return axios.post(
      '/api/rendering/admin/front/outsourcing/operatingRecord/projectRecord',
      params,
    )
  },
  queryProjectList(params) {
    return axios.post('/api/rendering/admin/front/outsourcing/project/queryProjectList', params)
  },
  matchingRateSetting(params) {
    return axios.post('/api/rendering/admin/front/outsourcing/project/matchingRateSetting', params)
  },
  getProjectCountStatInfo(params) {
    return axios.post(
      '/api/rendering/admin/front/outsourcing/project/getProjectCountStatInfo',
      params,
    )
  },
  getProjectDetails(params) {
    return axios.post('/api/rendering/admin/front/outsourcing/project/getProjectDetails', params)
  },
  getQualificationList(params) {
    return axios.post(
      '/api/rendering/admin/front/outsourcing/qualification/getQualificationList',
      params,
    )
  },
  qualificationRecord(params) {
    return axios.post(
      '/api/rendering/admin/front/outsourcing/operatingRecord/qualificationRecord',
      params,
    )
  },
  updateQualificationStatus(params) {
    return axios.post(
      '/api/rendering/admin/front/outsourcing/qualification/updateQualificationStatus',
      { channel: 5, ...params },
    )
  },
}
